import { render, staticRenderFns } from "./p2pAlarmWindow.vue?vue&type=template&id=7a86be12&scoped=true"
import script from "./p2pAlarmWindow.vue?vue&type=script&lang=js"
export * from "./p2pAlarmWindow.vue?vue&type=script&lang=js"
import style0 from "./p2pAlarmWindow.vue?vue&type=style&index=0&id=7a86be12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a86be12",
  null
  
)

export default component.exports